import { useCallback } from "react";
import { buildURL, useNavigation } from "@thenounproject/lingo-core";
import useHash from "../../../app/_lib/hooks/useHash";
import useNavPoint from "@hooks/useNavPoint";
import { NavPointTypes } from "@redux/navPoint/NavPoint";

// Pages that should redirect to kit overview when entering configure mode
const REDIRECT_TO_KIT_TYPES = [
  NavPointTypes.KitVersions,
  NavPointTypes.KitTrashedItems,
  NavPointTypes.KitRecoveredAssets,
];

const useConfigureMode = () => {
  const hash = useHash();
  const configureMode = hash === "#configure";
  const navigate = useNavigation();
  const navPoint = useNavPoint();

  const toggleConfigureMode = useCallback(() => {
    if (!configureMode) {
      // If we're on versions, deleted, or recovered pages, redirect to kit overview
      if (navPoint && REDIRECT_TO_KIT_TYPES.includes(navPoint.type)) {
        const { kit, space, portal } = navPoint;
        if (kit) {
          const kitUrl = buildURL(`/k/${kit.urlId}`, { space, portal });
          navigate.push(`${kitUrl}#configure`);
          return;
        }
      }
      // Otherwise, add #configure to current URL
      const components = [window.location.pathname, window.location.search, "#configure"];
      navigate.push(components.join(""));
    } else {
      // Exiting configure mode - just remove the hash
      const components = [window.location.pathname, window.location.search];
      navigate.push(components.join(""));
    }
  }, [configureMode, navigate, navPoint]);

  const enterConfigureMode = useCallback(() => {
    if (!configureMode) toggleConfigureMode();
  }, [configureMode, toggleConfigureMode]);

  return { configureMode, toggleConfigureMode, enterConfigureMode };
};

export default useConfigureMode;
